import React from "react";
import "./Legal.css";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const Legal = () => {
    return (
      <section className="">
        <Row>
          <Col xs={12} className="text-center">         
            <small className="mt-5 text-muted">.................legal.................</small>
          </Col>
        </Row>
      </section>
      );
    }
  
  export default Legal